import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import LargeQuote from './LargeQuote.jsx';


class LargeTextCard extends React.Component {
  constructor(props) {
    super(props);

    // top offset amount from the normal top position
    this.offsetTopAmount = 0;

    // random offset amount for animating when user scrolls
    this.randomOffsetAmount = 1 + (Math.random() * 2);

    // called when an animationFrame is rendering
    this.ticking = false;

    // used by React as the component name
    this.displayName = 'LargeTextCard';

    // bind functions to component
    this.renderQuote = this.renderQuote.bind(this);

    // bind functions to component
    this.setOffsetTopAmount = this.setOffsetTopAmount.bind(this);
  }


  /**
   * Called when component props or state updates
   * @param {Object} prevProps - The previous props
   * @returns {undefined} undefined
   */
  componentDidUpdate(prevProps) {
    const state = this.props.largeCardFrameworkState;

    if (!this.ticking &&
      (state.scrollTop !== prevProps.largeCardFrameworkState.scrollTop)) {
      this.ticking = true;

      window.requestAnimationFrame(() => {
        this.setOffsetTopAmount();
      });
    }
  }


  /**
   * Called when component mounts to DOM
   * @returns {undefined} undefined
   */
  componentDidMount() {
    this.node = ReactDOM.findDOMNode(this);
  }


  /**
   * Sets the top offset amount for the element
   * @returns {undefined} undefined
   */
  setOffsetTopAmount() {
    if (this.node) {
      const state = this.props.largeCardFrameworkState;

      if (this.node.offsetTop - state.scrollTop < window.innerHeight &&
        (this.node.offsetTop + this.node.offsetHeight) - state.scrollTop > 0) {
        this.offsetTopAmount =
          (((window.innerHeight / 2) - (this.node.offsetTop - state.scrollTop))
          * -0.1) * this.randomOffsetAmount;
      }

      this.ticking = false;
    }
  }


  /**
   * Renders quote
   * @returns {ReactElement} ReactElement
   */
  renderQuote() {
    const data = this.props.data;
    let element;

    if (data.quote) {
      const gridClass = 'quote-wrapper large-col-' + data.quote.largeGridColumns +
        ' large-push-' + data.quote.largeGridPush;
      element = (
        <div className={gridClass}>
          <LargeQuote
            data={data.quote}
          />
        </div>
      );
    }

    return element;
  }


  /**
   * Renders component
   * @returns {ReactElement} ReactElement
   */
  render() {
    const quote = this.renderQuote();
    const data = this.props.data;
    const gridClass = ' large-col-' + data.largeGridColumns +
      ' large-push-' + data.largeGridPush +
      ' large-top-push-' + data.largeTopPush;
    const style = {
      zIndex: this.props.iteration * 10,
      transform: 'translate3d(0, ' + this.offsetTopAmount + 'px, 0)',
    };
    const className = 'card component-large-text-card' + gridClass;

    return (
      <section
        className={className}
        style={style}
      >
        <div className='content-wrapper'>
          <div
            className='content'
            dangerouslySetInnerHTML={{ __html: data.content }}
          />
          {quote}
        </div>
      </section>
    );
  }
}


/**
 * Expected propTypes
 * @prop {Object} data - An array of card React components
 * @prop {Number} iteration - The iteration of the component
 * @prop {Object} largeCardFrameworkState - The state of the
 * LargeCardFramework component
 * @prop {Object} mediaLabCardFrameworkState - The state of the
 * container component
 * @prop {Object} style - A style object
 */
LargeTextCard.propTypes = {
  data: React.PropTypes.object.isRequired,
  iteration: React.PropTypes.number.isRequired,
  largeCardFrameworkState: React.PropTypes.object.isRequired,
  mediaLabCardFrameworkState: React.PropTypes.object.isRequired,
  style: React.PropTypes.object,
};


export default connect(({ mediaLabCardFrameworkState, largeCardFrameworkState }) =>
  ({ mediaLabCardFrameworkState, largeCardFrameworkState }))(LargeTextCard);



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/cards/large/LargeTextCard.jsx
 **/